import sgnricValidate from './SGNRICValidator.js';

export const taxFormats = {
  AR: {
    personal: {
      taxInfo: {
        countryName: 'Argentina',
        region: 'Americas',
        label: 'DNI (Documento Nacional de Identidad)',
        format: '########',
        allowData: 'numbers-only',
        fieldInService: 'BUS_REG',
        fieldInSAP: 'TAX3',
        maxLength: 8,
        regex: /[0-9]{8}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Argentina',
        region: 'Americas',
        label: 'CUIT (Clave Única de Identificación Tributaria)',
        format: '##-########-#',
        allowData: 'numbers-only',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 11,
        regex: /[0-9]{11}/,
        returnMaskedValue: false,
      },
    },
  },
  AT: {
    personal: {
      taxInfo: {
        countryName: 'Austria',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Austria',
        region: 'EMEA',
        label: 'VAT',
        format: 'AAA########',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 11,
        regex: /ATU[0-9]{8}/,
      },
    },
  },
  AU: {
    personal: {
      taxInfo: {
        countryName: 'Australia',
        region: 'Pacific ',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Australia',
        region: 'Pacific ',
        label: 'ABN',
        format: '##-###-###-###',
        allowData: 'numbers-only',
        fieldInService: 'BUS_REG',
        fieldInSAP: 'VAT',
        maxLength: 11,
        regex: /[0-9]{11}/,
      },
    },
  },
  BE: {
    personal: {
      taxInfo: {
        countryName: 'Belgium',
        region: 'EMEA',
        label: '',
        format: 'AA##########',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 0,
        regex: /^(BE)?[0-1]?[0-9]\d{9}$/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Belgium',
        region: 'EMEA',
        label: 'VAT',
        format: 'AA#########',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 11,
        regex: /^(BE)?[0-1]?[0-9]\d{9}$/,
        required: false,
      },
    },
  },
  BN: {
    personal: {
      taxInfo: {
        countryName: 'Brunei',
        region: 'SEA',
        label: 'NRIC/Brunei IC Number',
        format: '##-######',
        allowData: 'numbers-only ',
        fieldInService: 'TAX_ID ',
        fieldInSAP: 'TAX1',
        maxLength: 8,
        regex: /[0-9]{8}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Brunei',
        region: 'SEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  CA: {
    personal: {
      taxInfo: {
        countryName: 'Canada',
        region: 'Americas',
        label: 'SIN (Social Insurance Number)',
        format: '###-###-###',
        allowData: 'numbers-only',
        fieldInService: 'SSN',
        fieldInSAP: 'TAX1',
        maxLength: 9,
        regex: /[0-9]{3}-[0-9]{3}-[0-9]{3}/,
        returnMaskedValue: true,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Canada',
        region: 'Americas',
        label: 'EIN',
        format: '#########AA####',
        allowData: 'alphanumerics-only',
        fieldInService: 'FEDERAL',
        fieldInSAP: 'TAX1',
        maxLength: 15,
        regex: /[0-9]{9}[A-Za-z]{2}[0-9]{4}/,
      },
    },
  },
  CH: {
    personal: {
      taxInfo: {
        countryName: 'Switzerland',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Switzerland',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  CL: {
    personal: {
      taxInfo: {
        countryName: 'Chile',
        region: 'Americas',
        label: 'RUT (Rol Único Tributario)',
        format: '##.###.###-N',
        allowData: 'alphanumerics-only',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 9,
        regex: /[0-9]{8}[A-Za-z0-9]/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Chile',
        region: 'Americas',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  CO: {
    personal: {
      taxInfo: {
        countryName: 'Columbia',
        region: 'Americas',
        label: 'Cédula de Ciudadanía',
        format: '############',
        allowData: 'alphanumerics-only',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 12,
        regex: /[0-9]{8,12}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Columbia',
        region: 'Americas',
        label: 'NIT (Número de Identificación Tributaria)',
        format: '#######-N',
        allowData: 'numbers-only',
        fieldInService: 'BUS_REG',
        fieldInSAP: 'TAX3',
        maxLength: 8,
        regex: /[0-9]{7}[A-Za-z0-9]/,
      },
    },
  },
  CZ: {
    personal: {
      taxInfo: {
        countryName: 'Czech Republic',
        region: 'EMEA',
        label: 'Identification Card number',
        format: '',
        allowData: 'alphanumerics-only',
        fieldInService: 'KPP',
        fieldInSAP: 'TAX4',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Czech Republic',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  DE: {
    personal: {
      taxInfo: {
        countryName: 'Germany',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Germany',
        region: 'EMEA',
        label: 'VAT',
        format: 'AA#########',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 11,
        regex: /DE[0-9]{9}/,
      },
    },
  },
  DK: {
    personal: {
      taxInfo: {
        countryName: 'Denmark',
        region: 'EMEA',
        label: 'VAT',
        format: 'AA#########',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 11,
        regex: /[A-Za-z]{2}[0-9]{9}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Denmark',
        region: 'EMEA',
        label: 'VAT',
        format: 'AA#########',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 11,
        regex: /[A-Za-z]{2}[0-9]{9}/,
      },
    },
  },
  ES: {
    personal: {
      taxInfo: {
        countryName: 'Spain',
        region: 'EMEA',
        label: 'NIF/NIE',
        format: 'N#######N',
        allowData: 'alphanumerics-only',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 9,
        regex: /(?:[A-Z]{1}[0-9]{8}|[0-9]{8}[A-Z]|[A-Z]{1}[0-9]{7}[A-Z]{1})/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Spain',
        region: 'EMEA',
        label: 'IVA',
        format: 'AAN#######N',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 11,
        regex: /ES(?:[A-Z]{1}[0-9]{8}|[0-9]{8}[A-Z]|[A-Z]{1}[0-9]{7}[A-Z]{1})/,
      },
    },
  },
  FI: {
    personal: {
      taxInfo: {
        countryName: 'Finland',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Finland',
        region: 'EMEA',
        label: 'VAT',
        format: 'AA########',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 10,
        regex: /[A-Za-z][0-9]{8}/,
      },
    },
  },
  FR: {
    personal: {
      taxInfo: {
        countryName: 'France',
        region: 'EMEA',
        label: 'Social Security Number',
        format: '############# ##',
        allowData: 'numbers-only',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 15,
        regex: /[0-9]{15}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'France',
        region: 'EMEA',
        label: 'SIRET',
        format: '##############',
        allowData: 'numbers-only',
        fieldInService: 'BUS_REG',
        fieldInSAP: 'TAX3',
        maxLength: 14,
        regex: /[0-9]{15}/,
      },
    },
  },
  GB: {
    personal: {
      taxInfo: {
        countryName: 'United Kingdom',
        region: 'EMEA',
        label: 'VAT',
        format: 'AA#########',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 11,
        regex: /GB[0-9]{9}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'United Kingdom',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  HK: {
    personal: {
      taxInfo: {
        countryName: 'Hong Kong',
        region: 'Greater China',
        label: '',
        format: '*?*#####**',
        allowData: 'alphanumerics-only',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 9,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Hong Kong',
        region: 'Greater China',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  HU: {
    personal: {
      taxInfo: {
        countryName: 'Hungary',
        region: 'EMEA',
        label: 'Identification Card/Driving License',
        format: '',
        allowData: 'alphanumerics-only',
        fieldInService: 'KPP',
        fieldInSAP: 'TAX4',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Hungary',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  ID: {
    personal: {
      taxInfo: {
        countryName: 'Indonesia',
        region: 'SEA',
        label: 'NPWP (Tax ID number)',
        format: '##.###.###.#-###.###',
        allowData: 'numbers-only',
        fieldInService: 'KPP',
        fieldInSAP: 'TAX4',
        maxLength: 15,
        regex: /[0-9]{15}/,
        required: true,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Indonesia',
        region: 'SEA',
        label: 'NPWP (Tax ID number)',
        format: '##.###.###.#-###.###',
        allowData: 'numbers-only',
        fieldInService: 'KPP',
        fieldInSAP: 'TAX4',
        maxLength: 15,
        regex: /[0-9]{15}/,
      },
    },
  },
  IE: {
    personal: {
      taxInfo: {
        countryName: 'Ireland',
        region: 'EMEA',
        label: 'VAT',
        format: 'AA#N#####NN',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 8,
        regex: /IE(?:[\d]{7}(?:[A-Z]{1,2})|\d[A-Z][\d]{5}[A-Z])/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Ireland',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  IL: {
    personal: {
      taxInfo: {
        countryName: 'Israel',
        region: 'EMEA',
        label: 'Tax ID Number',
        format: '#########',
        allowData: 'numbers-only ',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 9,
        regex: /[0-9]{9}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Israel',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  IS: {
    personal: {
      taxInfo: {
        countryName: 'Iceland',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Iceland',
        region: 'EMEA',
        label: 'VAT',
        format: '######',
        allowData: 'numbers-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 6,
        regex: /[0-9]{6}/,
      },
    },
  },
  IT: {
    personal: {
      taxInfo: {
        countryName: 'Italy',
        region: 'EMEA',
        label: 'Fiscal Code Card',
        format: 'AAAAAA##A##A###A',
        allowData: 'alphanumerics-only',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 16,
        regex: /[A-Z]{6}(?:[0-9]{2}[A-Z]{1}){2}[0-9]{3}[A-Z]/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Italy',
        region: 'EMEA',
        label: 'VAT',
        format: 'AA###########',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 13,
        regex: /IT[0-9]{11}/,
      },
    },
  },
  JP: {
    personal: {
      taxInfo: {
        countryName: 'Japan',
        region: 'North Asia',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Japan',
        region: 'North Asia ',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  LU: {
    personal: {
      taxInfo: {
        countryName: 'Luxembourg',
        region: 'EMEA',
        label: '',
        format: 'AA########',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 0,
        regex: /LU[0-9]{8}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Luxembourg',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  MX: {
    personal: {
      taxInfo: {
        countryName: 'Mexico',
        region: 'Americas',
        label: 'RFC (Registro Federal de Contribuyentes)',
        format: 'AAAA######NNN',
        allowData: 'alphanumerics-only',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 13,
        regex: /[A-Za-z]{4}[0-9]{6}[0-9A-Za-z]{3}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Mexico',
        region: 'Americas',
        label: 'RFC (Registro Federal de Contribuyentes)',
        format: 'AAA######NNN',
        allowData: 'alphanumerics-only',
        fieldInService: 'IDENTITY',
        fieldInSAP: 'TAX2',
        maxLength: 12,
        regex: /[A-Za-z]{3}[0-9]{6}[0-9A-Za-z]{3}/,
      },
      taxInfo1: {
        countryName: 'Mexico',
        region: 'Americas',
        label: 'CURP (Clave Única de Registro de Población)',
        format: 'AAAA######NNNNNNNN',
        allowData: 'alphanumerics-only',
        fieldInService: 'IDENTITY',
        fieldInSAP: 'TAX3',
        maxLength: 18,
        regex: /[A-Za-z]{4}[0-9]{6}[0-9A-Za-z]{8}/,
      },
    },
  },
  MY: {
    personal: {
      taxInfo: {
        countryName: 'Malaysia',
        region: 'SEA',
        label: 'NRIC (Nation Registration Identity Card)',
        format: '######-##-####',
        allowData: '',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 14,
        regex: /\d{6}-\d{2}-\d{4}/,
        returnMaskedValue: true,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Malaysia',
        region: 'SEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  NC: {
    personal: {
      taxInfo: {
        countryName: 'New Caledonia',
        region: 'Pacific ',
        label: 'RIDET',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'New Caledonia',
        region: 'Pacific ',
        label: 'RIDET',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  NL: {
    personal: {
      taxInfo: {
        countryName: 'Netherlands',
        region: 'EMEA',
        label: 'BSN (personal number)',
        format: '',
        allowData: 'alphanumerics-only',
        fieldInService: 'BSN',
        fieldInSAP: 'TAX1',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Netherlands',
        region: 'EMEA',
        label: 'VAT',
        format: 'AA#########A##',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 14,
        regex: /NL[0-9]{9}B[0-9]{2}/,
      },
    },
  },
  NO: {
    personal: {
      taxInfo: {
        countryName: 'Norway',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Norway',
        region: 'EMEA',
        label: 'VAT',
        format: '#########',
        allowData: 'numbers-only ',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 9,
        regex: /[0-9]{9}/,
      },
    },
  },
  NZ: {
    personal: {
      taxInfo: {
        countryName: 'New Zealand',
        region: 'Pacific ',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'New Zealand',
        region: 'Pacific ',
        label: 'GST',
        format: '#########',
        allowData: 'numbers-only',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX2',
        maxLength: 9,
        regex: /[0-9]{8,9}/,
      },
    },
  },
  PE: {
    personal: {
      taxInfo: {
        countryName: 'Peru',
        region: 'Americas',
        label: 'DNI (Documento Nacional de Identidad)',
        format: '#########',
        allowData: '',
        fieldInService: 'BUS_REG',
        fieldInSAP: 'TAX3',
        maxLength: 9,
        regex: /[0-9]{8,9}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Peru',
        region: 'Americas',
        label: 'RUC (Registro Unico de Contribuyentes)',
        format: '###########',
        allowData: 'numbers-only',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 11,
        regex: /[0-9]{11}/,
      },
    },
  },
  PF: {
    personal: {
      taxInfo: {
        countryName: 'French Polynesia',
        region: 'Pacific ',
        label: "Le numero d'identification de mon parrain",
        format: '',
        allowData: 'alphanumerics-only',
        fieldInService: 'N/A',
        fieldInSAP: 'N/A ',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'French Polynesia',
        region: 'Pacific ',
        label: 'Numéro TAHITI',
        format: '*#####',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 5,
        regex: '',
      },
    },
  },
  PH: {
    personal: {
      taxInfo: {
        countryName: 'Phillipines',
        region: 'SEA',
        label: 'TIN (Tax Identification Number)',
        format: '###-###-###',
        allowData: 'numbers-only ',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 9,
        regex: /[0-9]{9}/,
        returnMaskedValue: false,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Phillipines',
        region: 'SEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  PL: {
    personal: {
      taxInfo: {
        countryName: 'Poland',
        region: 'EMEA',
        label: 'Identification Card Number',
        format: '',
        allowData: 'alphanumerics-only',
        fieldInService: 'KPP',
        fieldInSAP: 'TAX4',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Poland',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  PT: {
    personal: {
      taxInfo: {
        countryName: 'Portugal',
        region: 'EMEA',
        label: 'NIF/NIE',
        format: '#########',
        allowData: 'alphanumerics-only',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 9,
        regex: /[0-9]{9}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Portugal',
        region: 'EMEA',
        label: 'VAT',
        format: 'AA#########',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 11,
        regex: /PT[0-9]{9}/,
      },
    },
  },
  RO: {
    personal: {
      taxInfo: {
        countryName: 'Romania',
        region: 'EMEA',
        label: 'Identification Card number',
        format: '',
        allowData: 'alphanumerics-only',
        fieldInService: 'KPP',
        fieldInSAP: 'TAX4',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Romania',
        region: 'EMEA',
        label: 'Company Registration Number',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  RU: {
    personal: {
      taxInfo: {
        countryName: 'Russia',
        region: 'EMEA',
        label: 'Passport Number',
        format: '##########',
        allowData: '',
        fieldInService: 'PASSPORT',
        fieldInSAP: 'TAX2',
        maxLength: 10,
        regex: /[0-9]{10}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Russia',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  SE: {
    personal: {
      taxInfo: {
        countryName: 'Sweden',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Sweden',
        region: 'EMEA',
        label: 'VAT',
        format: 'AA############',
        allowData: 'alphanumerics-only',
        fieldInService: 'VAT',
        fieldInSAP: 'VAT',
        maxLength: 14,
        regex: /SE[0-9]{12}/,
      },
    },
  },
  SG: {
    personal: {
      taxInfo: {
        countryName: 'Singapore',
        region: 'SEA',
        label: 'NRIC (Nation Registration Identity Card)',
        format: 'A#######A',
        allowData: 'alphanumerics-only',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 9,
        regex: /[A-Za-z][0-9]{7}[A-Za-z]/,
        validationFunction: sgnricValidate,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Singapore',
        region: 'SEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  SK: {
    personal: {
      taxInfo: {
        countryName: 'Slovokia',
        region: 'EMEA',
        label: 'Identification Card Number',
        format: '',
        allowData: 'alphanumerics-only',
        fieldInService: 'KPP',
        fieldInSAP: 'TAX4',
        maxLength: 0,
        regex: '',
      },
    },
    business: {
      taxInfo: {
        countryName: 'Slovokia',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  TH: {
    personal: {
      taxInfo: {
        countryName: 'Thailand',
        region: 'EMEA',
        label: 'ID Card Number',
        format: '#############',
        allowData: 'numbers-only',
        fieldInService: 'TAX_ID ',
        fieldInSAP: 'TAX1',
        maxLength: 13,
        regex: /[0-9]{13}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Thailand',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  UA: {
    personal: {
      taxInfo: {
        countryName: 'Ukraine',
        region: 'EMEA',
        label: 'Passport Number',
        format: 'AA###### ',
        allowData: 'alphanumerics-only',
        fieldInService: 'KPP',
        fieldInSAP: 'TAX4',
        maxLength: 8,
        regex: /[A-Za-z]{2}[0-9]{6}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Ukraine',
        region: 'EMEA',
        label: '',
        format: '',
        allowData: '',
        fieldInService: '',
        fieldInSAP: '',
        maxLength: 0,
        regex: '',
      },
    },
  },
  US: {
    personal: {
      taxInfo: {
        countryName: 'United States',
        region: 'Americas ',
        label: 'SSN (Social Security Number)',
        format: '###-##-####',
        allowData: 'numbers-only',
        fieldInService: 'SSN',
        fieldInSAP: 'TAX1',
        maxLength: 11,
        regex: /^(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/,
        returnMaskedValue: true,
      },
    },
    business: {
      taxInfo: {
        countryName: 'United States',
        region: 'Americas ',
        label: 'EIN',
        format: '##-#######',
        allowData: 'numbers-only',
        fieldInService: 'FEDERAL',
        fieldInSAP: 'TAX1',
        maxLength: 9,
        regex: /[0-9]{9}/,
      },
    },
  },
  VN: {
    personal: {
      taxInfo: {
        countryName: 'Vietnam',
        region: 'SEA',
        label: 'Identity Card',
        format: '############',
        allowData: 'numbers-only',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 12,
        regex: /^([0-9]{12}|[0-9]{9})$/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'Vietnam',
        region: 'SEA',
        label: 'Tax Code',
        format: '##########',
        allowData: 'numbers-only',
        fieldInService: 'BUS_REG',
        fieldInSAP: 'TAX3',
        maxLength: 10,
        regex: /[0-9]{10}/,
      },
    },
  },
  ZA: {
    personal: {
      taxInfo: {
        countryName: 'South Africa',
        region: 'EMEA',
        label: 'Identity Number',
        format: '#############',
        allowData: 'numbers-only',
        fieldInService: 'IDENTITY ',
        fieldInSAP: 'TAX2',
        maxLength: 13,
        regex: /[0-9]{13}/,
      },
    },
    business: {
      taxInfo: {
        countryName: 'South Africa',
        region: 'EMEA',
        label: 'Income Tax Number',
        format: '####-###-##-#',
        allowData: 'numbers-only',
        fieldInService: 'TAX_ID',
        fieldInSAP: 'TAX1',
        maxLength: 10,
        regex: /[0-9]{10}/,
      },
    },
  },
};
